import { auth0Config } from "@/configs/auth-config";
import { WatchQueryFetchPolicy } from "@apollo/client";

export const userApiScope = {
  audience: auth0Config.managementAudience,
  scope: auth0Config.managementScope,
};

export const clientApiScope = {
  audience: auth0Config.clientAudiance,
  scope: auth0Config.clientScope,
};

export const Constants = {
  MANAGEMENT_API_URL: import.meta.env.VITE_MANAGEMENT_API_URL,
  CLIENTS_API_URL: import.meta.env.VITE_CLIENTS_API_URL,
};
export const FETCH_POLICY_NO_CACHE: WatchQueryFetchPolicy = "no-cache";
